var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FieldSet',{staticClass:"mt-48 mb-64",attrs:{"title":'Pago por transferencia'}},[_c('div',{staticClass:"text text--lg color-secondary",attrs:{"slot":"body"},slot:"body"},[_vm._v(_vm._s(_vm.literals.info))])])}
var staticRenderFns = []

export { render, staticRenderFns }